import React from "react";

const MASK = {
  WebkitMaskImage: "url(/idevra-mark-blue.png)",
  maskImage: "url(/idevra-mark-blue.png)",
};

// IDEVRA mark with live light running along its blue circuitry.
export default function LiveMark({ className = "" }) {
  return (
    <span className={`iv-live-mark ${className}`}>
      <img src="/idevra-mark.png" alt="IDEVRA" />
      <span className="iv-live-mark-glow" style={MASK} />
      <span className="iv-live-mark-light" style={MASK} />
    </span>
  );
}
